import React, { useEffect, useState } from 'react';
import { Card, Button, Row, Container, Col } from 'react-bootstrap';
import { FormatMoney } from '../../../utilities/formats';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { HomeWrapper } from '../../../shared/components/style'
import "react-multi-carousel/lib/styles.css";
import { Link } from 'react-router-dom';
import { idCardoso, idCardosoVendedor, idMobilgoVendedor } from '../../../utilities/odoo-config';
import { Desencrypt } from '../../../utilities/cipher';

export const CarruselExequiales = (props) => {
    const { exequiales = [] } = props;
    console.log("exequiales en carrusel", props.exequiales);
    const [cards, setCards] = useState([])
    

    const capturarRifa = async (id, name, imagen_medium) => {
        localStorage.setItem('datosSeguro', JSON.stringify({ id, name, imagen_medium}));
        console.log("Datos almacenados en el localStorage");
    }


    const size = useWindowSize();
    const [numberCards, setNumberCards] = useState(2);
    function useWindowSize() {

        const [windowSize, setWindowSize] = useState({ width: undefined, height: undefined, });

        useEffect(() => {
            function handleResize() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            window.addEventListener("resize", handleResize);
            handleResize();

            return () => window.removeEventListener("resize", handleResize);
        }, []);
        return windowSize;
    }

    useEffect(() => {

        if (size.width <= 768 && size.height <= 1024) {
            setNumberCards(1)
        }
        else if (size.width >= 768 && size.height >= 800) {
            setNumberCards(2)
        }

    }, [size]);


    let settings = {
        arrows: true,
        dots: false,
        accesibility: true,
        infinite: false,
        speed: 300,
        slidesToShow: numberCards,
        slidesToScroll: 1,
        adaptiveHeight: false
    };

    useEffect(() => {
        let aux = [];
        exequiales.forEach(element => {
            // console.log("element del carrusel rifa",element)
            if(element.active){
                
                aux.push(
                    <div key={element.id} className="col-xs-12" style={{ padding: '5' }}>
                        <Card className="text-center" border="info" style={{ margin: 'auto', minHeight: '29rem' }}>
                            <Card.Header>{element.name}</Card.Header>
                            <Card.Body>
                                <Card.Img src={'data:image/jpeg;base64,' + element.image_medium} style={{ maxHeight: '400px', maxWidth: '350' }} alt="Card image" />
                            </Card.Body>
                            <Card.Footer className="text-muted">
                                <Row>
                                    <Col>
                                        
                                            <Button variant="info" onClick={() => capturarRifa(element.id, element.name, element.image_medium)}>
                                                <Link to='/Rifas/Abonos' style={{ color: 'white' }}>Abonar</Link>
                                            </Button>
                                    </Col>
                                    <Col>
                                        <Button variant="info" onClick={() => capturarRifa(element.id, element.name, element.image_medium)}>
                                            <Link to="/Seguro-excequial/Comprar" style={{ color: 'white' }}> Comprar</Link>
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </div>
                ); 
            }
            
        })
        setCards(aux)
    }, []);

    return (

        <Container>
            <HomeWrapper>
                <div className="clearfix mt-1 mb-2">
                </div>
                <Col>

                </Col>
                <Slider {...settings} >

                    {cards}
                </Slider>
            </HomeWrapper>
        </Container>

    )
}